import React, { Suspense, lazy } from 'react';
import './firebase'; // Import to initialize Firebase and Analytics
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import Homepage from './components/Homepage';
import PageLoader from './components/PageLoader';
import './index.css';
import { LanguageProvider } from './LanguageContext';

const BookingPage = lazy(() => import('./booking/BookingPage'));

function App() {
  React.useEffect(() => {
    if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') return;
    isSupported().then(supported => {
      if (supported) logEvent(getAnalytics(), 'app_opened');
    }).catch(() => {});
  }, []);

  return (
    <LanguageProvider>
      {window.location.pathname.replace(/\/$/, '') === '/appointments'
        ? <Suspense fallback={<PageLoader fullPage label="Φόρτωση ραντεβού…" />}><BookingPage /></Suspense>
        : <Homepage />}
    </LanguageProvider>
  );
}

export default App;
